import React from "react";
import { useSelector } from "react-redux";
import { useAssetTypeIdentifiers } from "../../../../common/hooks";
import { helpers } from "../../../../common/lib";
import GridColumn from "../GridColumn";

type Props = {
    identifier1: string,
    identifier2: string,
    identifier3: string,
    identifier4: string,
    make: number,
    type: number
};

/**
 * Asset/Alt-asset Core Component
 */
export default ({
    identifier1 = "",
    identifier2 = "",
    identifier3 = "",
    identifier4 = "",
    make = 0,
    type = 0
}: Props) => {
    const { typesList } = useSelector((state) => state);
    const identifiers = useAssetTypeIdentifiers(type ? type : 0);
    const makeItem = helpers.getListItemForId(typesList.makes, make);
    const typeItem = helpers.getListItemForId(typesList.assetTypes, type);

    return identifiers ? (
        <>
            {<GridColumn label="vin" value={identifier1} />}
            {<GridColumn label="reg" value={identifier2} />}
            {identifier3 && (
                <GridColumn
                    label={identifiers.identifier3}
                    value={identifier3}
                />
            )}
            {identifier4 && (
                <GridColumn
                    label={identifiers.identifier4}
                    value={identifier4}
                />
            )}
            <GridColumn label="make" value={makeItem.name} />
            <GridColumn label="type" value={typeItem.name} />
        </>
    ) : null;
};
